import {DescriptionText, H1Text, H2Text} from "../../../../design";
import React from "react";
import {AmountDivideByHundred} from "../../../../helper";
import SmallScreenHeader from "../../../../components/smallscreen/header";
import currencyformatter from "../../../../utils/currencyformatter";

type Props = {
  payment: Object,
  whiteLabel: Boolean,
  bankImageUrl: String,
  totalPayable: number,
}

const Header = (props:Props) => {
  const { payment, bankImageUrl, whiteLabel, totalPayable } = props;
  const largeLogo = (payment && payment.account && payment.account.largeLogo) ? payment.account.largeLogo : null;
  return (
    <SmallScreenHeader paymentCheckout={true} bankImageUrl={bankImageUrl} largeLogo={largeLogo} whiteLabel={whiteLabel}>
      <H1Text>
        Payment Checkout
      </H1Text>
      <H2Text>
        Payment For
      </H2Text>
      <DescriptionText>
        {payment && payment.description}
      </DescriptionText>
      <H2Text>
        Amount Payable
      </H2Text>
      <DescriptionText fontSize="24px">
        {totalPayable ? `${currencyformatter(AmountDivideByHundred(totalPayable), payment.currency && payment.currency.name)}`
        : payment ? `${currencyformatter(AmountDivideByHundred(payment.amount), payment.currency && payment.currency.name)}` : null }
      </DescriptionText>
    </SmallScreenHeader>
  )
};

export default Header;
